import * as React from "react";
import { Ref, SVGProps, forwardRef } from "react";
const SvgComponent = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    ref={ref}
    className="social-icon"
    {...props}
  >
    <path
      className="primary-path"
      fill="#111"
      fillOpacity={0.44}
      d="M18.326 2.404H21.7l-7.37 8.424L23 22.29h-6.789l-5.317-6.952L4.81 22.29H1.434l7.883-9.01L1 2.404h6.961l4.806 6.355 5.56-6.355Zm-1.184 17.867h1.87L6.945 4.317H4.94l12.203 15.954Z"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
